import * as React from 'react';
import * as ReactGA from 'react-ga';
import { useDispatch, useSelector } from 'react-redux';
import { ButtonMultiSwitch, ButtonSwitch } from '../buttonswitch';
import {
  changeHighlightViewedAction,
  changeNightModeAction,
  changeNsfwAction,

  // changeUpNextClientPersistent,
  selectHighlightViewed,
  selectNightMode,
  selectShowMedia,
  selectShowNsfw,

  // selectUpNext,
  selectCommentsUnderVideo,
  changeCommentsUnderVideoPersistent,
} from '../../ducks';
import { documentSetCookie } from '../../cookie';
import { SETTINGSMENU } from '../../lib/labels';
import { adBreakPoint } from '../../lib/helpers';
import { useChangeMediaFilter, useCurrentBreakPoint } from '../commons';

const filterMediaOptions = [
  { name: SETTINGSMENU.OPTIONS.ALL, value: '' },
  { name: SETTINGSMENU.OPTIONS.VIDEO, value: '/video' },
  { name: SETTINGSMENU.OPTIONS.IMAGES, value: '/foto' },
];

const menuGAEvent = (action, boolean) => ReactGA.event({
  category: 'Menu',
  action: action,
  label: `${action}${boolean ? 'Off' : 'On'}`,
});

export const ButtonSwitchNSFW = () => {
  const showNsfw = useSelector(selectShowNsfw);
  const dispatch = useDispatch();
  return (
    <ButtonSwitch
      labelText={SETTINGSMENU.OPTIONS.SHOW_NFSW}
      id={'nsfw_items'}
      onSelect={() => {
        documentSetCookie('filterNsfw', !showNsfw);
        dispatch(changeNsfwAction(!showNsfw));
        menuGAEvent('NsfwToggle', showNsfw);
      }}
      value={showNsfw}
    />
  );
};

export const SettingsOptions = ({ showOnlyFilter }) => {
  const showMedia = useSelector(selectShowMedia);
  const showNightMode = useSelector(selectNightMode);
  const highlightViewed = useSelector(selectHighlightViewed);

  // const upNext = useSelector(selectUpNext);
  const commentsUnderVideo = useSelector(selectCommentsUnderVideo);
  const currentBreakPoint = useCurrentBreakPoint();
  const dispatch = useDispatch();
  const changeMediaFilter = useChangeMediaFilter();
  return (
    <div>
      {!showOnlyFilter && (
        <>
          <ButtonSwitch
            labelText={SETTINGSMENU.OPTIONS.SHOW_NIGHTMODE}
            id={'day_or_night_mode'}
            onSelect={() => {
              documentSetCookie('nightMode', !showNightMode);
              dispatch(changeNightModeAction());
              menuGAEvent('DayNightModeToggle', showNightMode);
            }}
            value={showNightMode}
          />
          <ButtonSwitchNSFW />
          <ButtonSwitch
            labelText={SETTINGSMENU.OPTIONS.HIGHLIGHT_VIEWED}
            id={'highlight_viewed_items'}
            onSelect={() => {
              documentSetCookie('highlightViewed', !highlightViewed);
              dispatch(changeHighlightViewedAction());
              menuGAEvent('HighlightToggle', highlightViewed);
            }}
            value={highlightViewed}
          />
          {/*
          <ButtonSwitch
            labelText={SETTINGSMENU.OPTIONS.UP_NEXT}
            id={'up_next'}
            onSelect={() => dispatch(changeUpNextClientPersistent(!upNext))}
            value={upNext}
          />
          */}
          {['L', 'XL'].includes(adBreakPoint(currentBreakPoint)) &&
            <ButtonSwitch
              labelText={SETTINGSMENU.OPTIONS.COMMENTS_UNDER_VIDEO}
              id={'comments_under_item'}
              onSelect={() => dispatch(changeCommentsUnderVideoPersistent(!commentsUnderVideo))}
              value={commentsUnderVideo}
            />
          }
        </>
      )}
      <h3>{SETTINGSMENU.TITLE.FILTER_ITEMS}</h3>
      <ButtonMultiSwitch name="filterMedia"
        onSelect={changeMediaFilter}
        label={!showOnlyFilter ? SETTINGSMENU.OPTIONS.LABEL : null}
        options={filterMediaOptions}
        value={showMedia}/>
    </div>
  );
};
